<ng-content></ng-content>
<div
  class="tooltip-content"
  [class.close]="isEnabled(close)"
  [class.top]="isEnabled(top)"
  [class.right]="isEnabled(right)"
  [class.left]="isEnabled(left)"
  [class.no-click]="isEnabled(noClick)"
>
  <ng-content select="[content]"></ng-content>
</div>
